export const Logo = (props) => {
  const { src = "/assets/logos/image-removebg-preview.png" } = props;
  return (
    <img {...props} 
    src={src} />
  );
};
